import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './lib/auth.jsx';
import { I18nProvider } from './lib/i18n.jsx';
import { ToastProvider } from './lib/toast.jsx';
import { DialogProvider } from './lib/dialog.jsx';
import './styles.css';

// Matches Vite's base ("/" in dev, "/account/" in the deployed build) so
// client-side routes resolve whether served at the root or under the mount.
const basename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nProvider>
      <ToastProvider>
        <DialogProvider>
          <BrowserRouter basename={basename}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </DialogProvider>
      </ToastProvider>
    </I18nProvider>
  </React.StrictMode>,
);
